import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=dd1e334c&scoped=true&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"
import style0 from "./Menus.vue?vue&type=style&index=0&id=dd1e334c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1e334c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VBtnToggle,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VChip,VContainer,VDataTable,VDialog,VDivider,VFlex,VForm,VIcon,VLayout,VPagination,VProgressCircular,VSelect,VSnackbar,VSpacer,VTextField,VTreeview})
